import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import katex from 'katex'
import 'katex/dist/katex.css'
// 引入katex下的自动渲染函数
import renderMathInElement from 'katex/contrib/auto-render/auto-render'
// 定义自动渲染的配置参数,这些参数根据你的需求进行修改，下面的参数是官网上抄下来的
const renderOption = {
	delimiters: [
		{left: '$$', right: '$$', display: true},
		{left: '$', right: '$', display: false},
		{left: '\\(', right: '\\)', display: false},
		{left: '\\[', right: '\\]', display: true}
	],
	throwOnError: false
}

import '@/icons' // svg 便捷使用
import VueRx from 'vue-rx'
Vue.use(VueRx)
import global from './global'
import { isElectron } from './utils/common';


//全局配置注入
global.install = function() {
	Object.defineProperty(Vue.prototype, '$g', {
		get() {
			return global
		}
	})
}
Vue.use(global)
Vue.prototype.$isElectron = isElectron;
// 挂载自动渲染函数到vue原型
Vue.prototype.$formula = function(dom) {
	renderMathInElement(dom, renderOption)
}

import './permission'
import './utils/index'
import './assets/iconfont/iconfont.css'
import LoadScript from 'vue-load-script-plus'
Vue.use(LoadScript)
// import './mock'

Vue.config.productionTip = false

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
